import UnderConstruction from "./pages/UnderConstruction";
import "./assets/styles/main.css";

function App() {
  return (
    <>
      <UnderConstruction />

    </>
  );
}

export default App;